import IconSelector from "../GlobalComponents/IconSelector";
import Icon from "../GlobalComponents/Icon";
import React, { useEffect, useRef, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import settings from "../../settings";
import FetchResponses from "../../models/FetchResponses";
import Pagination from "react-js-pagination";
import Error from "./Error";
import PageLoader from "../GlobalComponents/PageLoader";
import { Modal } from 'antd'

export default function CardCarousel({
  ActiveDraggable = false,
  initialCards = [],
  title = true,
  edit = false,
  updateCards,
}) {
  const [cards, setCards] = useState(() => {
    return [...initialCards].sort((a, b) => a.order - b.order);
  });

  useEffect(() => {
    let cards = [...initialCards].sort((a, b) => a.order - b.order);
    setCards(cards);
  }, [initialCards]);

  const [cardToSave, setCardToSave] = useState({
    id: null,
    title: "",
    icon: "",
    content: "",
    visible: true,
    link: "",
    order: cards.length + 1,
  });

  const confirm = Modal.confirm
  const [loading, setLoading] = useState(false)

  const [editCardEnable, setEditCardEnable] = useState(false);

  const [open, setOpen] = useState(false);
  const [error_message, setErrorMessage] = useState('')


  const onDragEnd = (result) => {
    if (!result.destination) return;

    // Paso 1: Obtener solo las visibles
    const visibleCards = cards.filter((card) => card.visible);

    // Paso 2: Obtener la tarjeta arrastrada y su nueva posición
    const draggedCard = visibleCards[result.source.index];
    const newPositionCard = visibleCards[result.destination.index];

    // Paso 3: Reordenar dentro del array completo
    const reordered = Array.from(cards);

    // Eliminar la tarjeta arrastrada de su posición original
    const fromIndex = cards.findIndex((c) => c.id === draggedCard.id);
    reordered.splice(fromIndex, 1);

    // Insertar en la nueva posición (después de recalcular índice real)
    const toIndex = cards.findIndex((c) => c.id === newPositionCard.id);
    reordered.splice(toIndex, 0, draggedCard);

    // Paso 4: Actualizar órdenes si los necesitas
    const updated = reordered.map((card, index) => ({ ...card, order: index }));

    // Paso 5: Guardar estado y persistir
    setCards(updated);
    saveCardsOrder(updated);
  };

  const saveCardsOrder = (cardsAGuardar) => {
    let url = settings.backend.hereYouCanBulkUpdate;

    let body = Object.values(cardsAGuardar);

    fetch(url, {
      method: "PUT",
      headers: settings.headers_super_auth,
      body: JSON.stringify(body),
    })
      .then(FetchResponses.processResponse)
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  };

  const saveCard = (event) => {
    event.preventDefault();
    
    let saveMethod = "POST";
    let url = settings.backend.hereYouCan;
    
    if (cardToSave.id) {
      saveMethod = "PUT";
      url = url + cardToSave.id + "/";
    } else {
      delete cardToSave.id;
    }
    
    if(cardToSave.icon == '') {
      setOpen(true)
      setErrorMessage('Debe seleccionar un icono')
      return
    };
    
    let body = cardToSave;
    
    setLoading(true)
    fetch(url, {
      method: saveMethod,
      headers: settings.headers_super_auth,
      body: JSON.stringify(body),
    })
      .then(FetchResponses.processResponse)
      .then((response) => {
        updateCards();
        setEditCardEnable(false);
        setLoading(false)
      })
      .catch((error) => {
        setOpen(true)
        setErrorMessage('Hubo un error al guardar la tarjeta')
        setLoading(false)
      });
  };

  const handleClose = () => {
    setOpen(false)
    setErrorMessage('')
  }

  const enableCreateForm = () => {
    setCardToSave({
      id: null,
      title: "",
      icon: "",
      content: "",
      visible: false,
      link: "",
      order: cards.length + 1,
    });
    setEditCardEnable(true);
  };

  const deleteCard = (event) => {
      let idcard = event.currentTarget.getAttribute("idcard");
      let card = cards.filter((card) => card.id == idcard);
      let cantidadVisibles = cards.filter((card) => card.visible);

      if(card[0].visible && cantidadVisibles.length <= 3 ) {
        let error = "Puede tener minimo 3 tarjetas visibles"
        setErrorMessage(error)
        setOpen(true)
        return;
      }


      confirm({
        content: `¿Está seguro de que desea eliminar la tarjeta`,
        okText: 'Sí',
        cancelText: 'Cancelar',
        confirmLoading: loading,
        onOk() {
          let url = settings.backend.hereYouCan + idcard + '/';
          fetch(url, {
            method: 'delete',
            headers: settings.headers_super_auth
          })
            .then(FetchResponses.processResponse)
            .then((response) => {
              updateCards();
            })
            .catch((error) => {
              updateCards();
              console.log(error);
            });
        },
        onCancel() { },
      })  
  }

  const renderCardCarousel = () => {
    return (
      <div className="card-carousel-main-container">
        <div className="maintitle-container-cards">
          {title && <h2 class="card-carousel__maintitle">Aquí Puedes</h2>}
        </div>
        <div className="card-carousel">
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="cards" direction="horizontal">
              {(provided) => (
                <div
                  className="card-carousel__container"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {cards
                    .filter((card) => card.visible)
                    .map((card, index) => (
                      <Draggable
                        isDragDisabled={!ActiveDraggable}
                        key={index}
                        draggableId={String(index)}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            className="card-carousel__card"
                            onClick={() => window.open(card.link, "_blank")}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <div className="card-carousel__header">
                              <div className="card-carousel__icon-container">
                                <Icon
                                  name={card.icon}
                                  size={16}
                                  color="#062147"
                                />
                              </div>
                              <h3 className="card-carousel__title">
                                {card.title}
                              </h3>
                            </div>
                            <p className="card-carousel__content">
                              {card.content}
                            </p>
                          </div>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
    );
  };

  const handleEditCard = (event) => {
    let idcard = event.currentTarget.getAttribute("idcard");
    let editableCard = cards.filter((card) => card.id == idcard)[0];
    setCardToSave(editableCard);
    setEditCardEnable(true);
  };

  const handleChangeEditCard = (event) => {
    const { id, value, checked } = event.target;
    let valueSave = id == "visible" ? checked : value;
    if (id === "visible") {
      let cantidadVisibles = cards.filter((card) => card.visible);

      if (cantidadVisibles.length <= 3 && !valueSave) {
        let error = "Puede tener minimo 3 tarjetas visibles"
        setErrorMessage(error)
        setOpen(true)
        return;
      } else if (cantidadVisibles.length >= 5 && valueSave) {
         let error = "Puede tener maximo 5 tarjetas visibles"
        setErrorMessage(error)
        setOpen(true)
        return;
      }
    }
    setCardToSave((prev) => ({
      ...prev,
      [id]: valueSave,
    }));
  };

  const handlePageChange = active_page => {
  }

  const renderEditCards = () => {
    return (
      <div className="edit-cards-container">
        {editCardEnable ? (
          <form className="form-edit-cards" onSubmit={saveCard}>
            <div>
              <span className="carrusel--subtitle">Titulo</span>
              <input
                type="text"
                className="form-control"
                //readOnly
                value={cardToSave.title}
                onChange={handleChangeEditCard}
                field="title"
                id="title"
                placeholder="Titulo"
                required
              />
            </div>

            <div className="card-edit-icon-selector">
              <span className="carrusel--subtitle">Icono</span>
              <Icon name={cardToSave.icon} size={32} />
              <p>{cardToSave.icon}</p>
              <IconSelector
                value={cardToSave.icon}
                onChange={handleChangeEditCard}
              />
            </div>

            <div>
              <span className="carrusel--subtitle">Descripcion</span>
              <input
                type="text"
                className="form-control"
                onChange={handleChangeEditCard}
                //readOnly
                value={cardToSave.content}
                field="content"
                placeholder="Descripcion"
                id="content"
                required
              />
            </div>

            <div>
              <span className="carrusel--subtitle">Link</span>
              <input
                type="url"
                className="form-control"
                onChange={handleChangeEditCard}
                //readOnly
                value={cardToSave.link}
                field="link"
                id="link"
                placeholder="Link"
                required
              />
            </div>

            <label className="carrusel--subtitle">Visible</label>
            <div className="form-check form-switch m-0">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id={`visible`}
                checked={cardToSave.visible}
                style={{
                  transform: "scale(1.3)",
                  cursor: "pointer",
                  backgroundColor: cardToSave.visible ? "#a00" : "",
                  borderColor: cardToSave.visible ? "#a00" : "",
                }}
                onChange={handleChangeEditCard}
              />
            </div>

            <div className="form-edit-cards-buttons">
              <button
                className="btn btn-outline-secondary"
                onClick={() => {
                  setEditCardEnable(false);
                }}
                type="button"
              >
                Cancelar
              </button>
              <button
                className="btn btn-primary"
                style={{ background: "#a00", borderColor: "#a00" }}
                type="submit"
              >
                Guardar
              </button>
            </div>
          </form>
        ) : (
          <div className="table-edit-cards">
            <div className="table-responsive">
              <table
                className="table table-striped table-sm"
                style={{ overflowX: "auto", whiteSpace: "nowrap" }}
              >
                <thead>
                  <tr style={{ fontSize: "1.6em" }}>
                    <th className="text-left-important" scope="col">
                      Icono
                    </th>
                    <th className="text-left-important" scope="col">
                      Titulo
                    </th>
                    <th className="text-left-important" scope="col">
                      Descripcion
                    </th>
                    <th className="text-left-important" scope="col">
                      Estado
                    </th>
                    <th className="text-left-important" scope="col">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: "1.4em" }}>
                  {cards.length > 0 &&
                    cards.map((card, index) => {
                      return (
                        <tr key={card.id}>
                          <td>
                            <Icon name={card.icon} size={32} color="blue" />
                          </td>
                          <td>{card.title}</td>
                          <td>{card.content}</td>
                          <td>{card.visible == 1 ? "VISIBLE" : "OCULTO"}</td>
                          <td>
                            <button
                              className="non-button ms-2"
                              idcard={card.id}
                              type="button"
                              onClick={handleEditCard}
                            >
                              <span className="icon dripicons-pencil" />
                            </button>

                            <button
                              className="non-button ms-2"
                              idcard={card.id}
                              type="button"
                              onClick={deleteCard}
                            >
                              <span className="icon dripicons-trash" />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="ps-4 row">
              <button
                className="btn btn-primary btn-sm col-sm-4"
                style={{
                  background: "#a00",
                  borderColor: "#a00",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  enableCreateForm();
                }}
              >
                Crear Tarjeta
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {loading && <PageLoader/>}
      {renderCardCarousel()}

      {edit && renderEditCards()}

      <Error
        open={open}
        error_message={error_message}
        handleClose={handleClose}
      />
    </>
  );
}
